import Axios from "axios";
import {
    SET_CUSTOMER_LIST,
    UNSET_CUSTOMER_LIST
  } from "@/store/mutation-types";
import { saveUpdateCustomer, getCustomerList, getCustomerById } from "@/store/api";
// initial state
const state = {
  getCustomerList: [],
  editingCustomer: null,
};

const getters = {
  getCustomerList(state) {
    return state.getCustomerList;
  },
  getEditingCustomer: (state) => state.editingCustomer,
};

const mutations = {
  [SET_CUSTOMER_LIST](state, data) {
    state.getCustomerList = data;
  },
  [UNSET_CUSTOMER_LIST](state) {
    state.getCustomerList = [];
  },
  setEditingCustomer(state, customer) {
    state.editingCustomer = customer;
  },
  clearEditingCustomer(state) {
    state.editingCustomer = null;
  }
};

const actions = {

  saveUpdateCustomer({ commit }, data) {
    commit("SET_LOADING", {color: "primary"});
    return new Promise((resolve, reject) => {
      Axios.post(saveUpdateCustomer, data)
        .then(function (response) {
          resolve(response);
          
        })
        .catch(function (error) {

          reject(error);
        })
        .then((always) => {
            commit("UNSET_LOADING");
        });
    });
  },

  getCustomerList({ commit }, data) {
    return new Promise((resolve, reject) => {
      Axios.post(getCustomerList, data)
        .then(function (response) {
          commit('SET_CUSTOMER_LIST', response.data.data)
          resolve(response);
        })
        .catch(function (error) {
          commit('UNSET_CUSTOMER_LIST')
          reject(error);
        })
        .then((always) => {
        });
    });
  },

  getCustomerById({ commit }, data) {
    const getCustomerByIdAPI = `${getCustomerById}/${data}`;
    commit("SET_LOADING", {color: "primary"});  
    return new Promise((resolve, reject) => {
      Axios.get(getCustomerByIdAPI)
        .then((response) => {
          resolve(response.data.data);
          commit("UNSET_LOADING"); 
        })
        .catch((error) => {
          reject(error);
          commit("UNSET_LOADING"); 
        });
    });
  },

  getGeneratedCustomerCode({ commit }) {
    return new Promise((resolve, reject) => {
      Axios.get(generateCustomerCode)
        .then((response) => {
          resolve(response.data.code);
        })
        .catch((error) => {
          reject(error);
        });
    });
  },


};

export default {
  state,
  getters,
  actions,
  mutations,
};
